export function transl(x: number, y: number) {
  return `translate(${x},${y})`;
}
